/* ==========================================================================
   YUMMY GUMMY — strip trailing ".00" decimals from displayed prices
   --------------------------------------------------------------------------
   The store's money format is "Rs.{{amount}}", which Shopify always renders
   with two decimals (e.g. Rs.2,199.00). Changing that store-wide is a
   Shopify Admin setting (Settings → General → Currency formatting: swap
   {{amount}} for {{amount_no_decimals}}); this theme-side script is the
   no-Admin fallback — it rewrites the RENDERED text so amounts read
   "Rs.2,199" instead of "Rs.2,199.00".

   Scope & safety:
   • Only rewrites text nodes, never attributes/values, so form inputs,
     data-* attributes and the real cart totals sent to Shopify are untouched
     (Shopify still charges the exact amount; this is display-only).
   • Only strips a ".00" (whole-rupee) decimal. A non-zero fractional part
     (e.g. Rs.2,199.50) is LEFT INTACT so we never hide real paise.
   • Runs on load and via a MutationObserver so AJAX-injected prices
     (cart drawer, quick-add, section re-renders) are cleaned too.
   ========================================================================== */
(function () {
  'use strict';

  // Rs.<digits, optional thousands separators>.00  →  drop the ".00".
  // The (^|non-digit) guard stops us from eating digits mid-number; we only
  // target a rupee-prefixed amount whose decimal part is exactly two zeros.
  var RS_ZERO_DECIMALS = /(Rs\.?\s?\d[\d,]*)\.00(?!\d)/g;

  function cleanString(text) {
    if (text.indexOf('.00') === -1) return text;
    return text.replace(RS_ZERO_DECIMALS, '$1');
  }

  function cleanTextNode(node) {
    var original = node.nodeValue;
    if (!original || original.indexOf('.00') === -1) return;
    var cleaned = cleanString(original);
    if (cleaned !== original) node.nodeValue = cleaned;
  }

  function walk(root) {
    if (!root) return;
    // Element → walk its text descendants; text node → clean directly.
    if (root.nodeType === Node.TEXT_NODE) {
      cleanTextNode(root);
      return;
    }
    if (root.nodeType !== Node.ELEMENT_NODE && root.nodeType !== Node.DOCUMENT_NODE) return;

    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) {
        // Skip script/style/textarea/input content — display text only.
        var parent = n.parentNode;
        if (!parent) return NodeFilter.FILTER_REJECT;
        var tag = parent.nodeName;
        if (tag === 'SCRIPT' || tag === 'STYLE' || tag === 'TEXTAREA' || tag === 'OPTION') {
          return NodeFilter.FILTER_REJECT;
        }
        return n.nodeValue && n.nodeValue.indexOf('.00') !== -1
          ? NodeFilter.FILTER_ACCEPT
          : NodeFilter.FILTER_SKIP;
      }
    });
    var current;
    var batch = [];
    while ((current = walker.nextNode())) batch.push(current);
    batch.forEach(cleanTextNode);
  }

  function run() {
    walk(document.body);

    // Watch for AJAX-added/changed prices (cart drawer, quick-add, facets,
    // section rendering). Debounced via rAF so a burst of mutations from one
    // re-render is handled in a single pass.
    if (!('MutationObserver' in window)) return;
    var queued = false;
    var pendingRoots = [];
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        if (m.type === 'characterData') {
          pendingRoots.push(m.target);
        } else {
          m.addedNodes && m.addedNodes.forEach(function (n) { pendingRoots.push(n); });
        }
      });
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () {
        queued = false;
        var roots = pendingRoots;
        pendingRoots = [];
        roots.forEach(walk);
      });
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
